// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_jc-5";
export var filledCircle = "_jc-4";
export var historyEntry = "_jc-3";
export var messageSideLeft = "_jc-1";
export var messageSideRight = "_jc-2";
export var orderTrackingCarouselWrapper = "_jc-6";
export var orderTrackingInfoContainer = "_jc-0";